import { createABTestApi } from '@/api/bff-methods/ab-test';
import { createAccountApi } from '@/api/bff-methods/account';
import { createAddressApi } from '@/api/bff-methods/address';
import { createAuthApi } from '@/api/bff-methods/auth';
import { createCartApi } from '@/api/bff-methods/cart';
import { createCatalogApi } from '@/api/bff-methods/catalog';
import { createCodeApi } from '@/api/bff-methods/code';
import { createContentLandingPagesApi } from '@/api/bff-methods/content-landing-pages';
import { createFavoritesApi } from '@/api/bff-methods/favorites';
import { createMediaBannersApi } from '@/api/bff-methods/media-banners';
import { createNotificationsApi } from '@/api/bff-methods/notifications';
import { createPersEventApi } from '@/api/bff-methods/pers-event';
import { createProductApi } from '@/api/bff-methods/product';
import { createQuestionsApi } from '@/api/bff-methods/questions';
import { createRecommendationsApi } from '@/api/bff-methods/recommendations';
import { createReviewsApi } from '@/api/bff-methods/reviews';
import { createSeoApi } from '@/api/bff-methods/seo';
import { createSettingsApi } from '@/api/bff-methods/settings';

import { type FetcherAxiosInstance } from './fetcher';

export type CreateApiBFFReturnType = ReturnType<typeof createApiBFF>;

export const createApiBFF = (Fetcher: FetcherAxiosInstance) => ({
  instance: Fetcher,

  ...createABTestApi(Fetcher),
  ...createAccountApi(Fetcher),
  ...createAddressApi(Fetcher),
  ...createAuthApi(Fetcher),
  ...createCartApi(Fetcher),
  ...createCatalogApi(Fetcher),
  ...createCodeApi(Fetcher),
  ...createContentLandingPagesApi(Fetcher),
  ...createFavoritesApi(Fetcher),
  ...createNotificationsApi(Fetcher),
  ...createPersEventApi(Fetcher),
  ...createProductApi(Fetcher),
  ...createQuestionsApi(Fetcher),
  ...createRecommendationsApi(Fetcher),
  ...createReviewsApi(Fetcher),
  ...createSeoApi(Fetcher),
  ...createSettingsApi(Fetcher),
  ...createMediaBannersApi(Fetcher),
});
